export const COLOR_INVALID = '#e74a3b7d';
export const COLOR_VALID = '#5ce73b';
